import gql from 'graphql-tag';

export const instiutionStatesGQL = gql`
  query ($instId: String!, $outOfState: Boolean) {
    institutionStates(inst_id: $instId, out_of_state: $outOfState) {
      state_name
      state_code
      region_name
    }
  }
`;

export const allMajorsGQL = gql`
  query ($orgID: String!) {
    organization(orgID: $orgID) {
      registration {
        majors {
          value: title
          label: title
        }
      }
    }
  }
`;
